'use client';

import { Input  } from '@chakra-ui/react';
import type { InputProps } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

import type { FormBaseInputProps } from '../../../types';
import { FormFloatingField } from '../../wrapper';

type TextInputProps<T> = FormBaseInputProps<T> & Omit<InputProps, 'name'>;

export const DateInput = <T extends Record<string, unknown>>({
	helperText,
	label,
	name,
	optionalText,
	required,
	...textInputProps
}: TextInputProps<T>) => {
	const { register } = useFormContext<T>();

	return (
		<FormFloatingField
			helperText={helperText}
			label={label}
			name={name}
			optionalText={optionalText}
			required={required}
		>
			<Input {...register(name)} type="date" {...textInputProps} />
		</FormFloatingField>
	);
};
